import * as Yup from "yup";
import { flow } from "./flow";

const {
  formField: { flowName, description },
} = flow;

export const flowsValidation = Yup.object().shape({
  [flowName.name]: Yup.string().required(flowName.errorMsg).max(50),
  [description.name]: Yup.string().max(500),
});
